import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'AutoshipPage' | 'ManageOrder' | 'AutoshipUtils' | 'PointsPayout';

/**
 * Errors related to the Activate Offer page
 */
export const Errors = createErrors<Page, Component>('Autoship')({
    AutoshipPage: {
        SetOrdergrooveAuthCookieFailed: {
            severity: 'HIGH',
            message: 'Failed to set Ordergroove auth cookie for Autoship page',
        },
        LoadOrdergrooveScriptFailed: {
            severity: 'HIGH',
            message: 'Failed to load Ordergroove script on Autoship page',
        },
        NoOgCustomerIdFound: {
            severity: 'MEDIUM',
            message: 'No OG customerId found',
        },
        GenerateOrdergrooveAuthSignatureFailed: {
            severity: 'HIGH',
            message: 'Failed to generate Ordergroove auth signature',
        },
        SaveAutoshipFromModalFailed: {
            severity: 'HIGH',
            message: 'Failed to save autoship from modal',
        },
        RemoveAutoshipFromModalFailed: {
            severity: 'HIGH',
            message: 'Failed to save autoship from modal',
        },
        MoveToNextAutoshipFailed: {
            severity: 'HIGH',
            message: 'Failed to move to next autoship',
        },
        GetNextRecurringOrderFailed: {
            severity: 'HIGH',
            message: 'Failed to get next recurring order',
        },
        FetchSubscriptionOrdersFailed: {
            severity: 'HIGH',
            message: 'Failed to fetch subscription orders from API',
        },
        CancelSubscriptionFailed: {
            severity: 'HIGH',
            message: 'Failed to cancel subscription',
        },
        ReactivateSubscriptionFailed: {
            severity: 'HIGH',
            message: 'Failed to reactivate subscription',
        },
        UpdatePlaceDateFailed: {
            severity: 'HIGH',
            message: 'Failed to update subscription order place date',
        },
        UpdatePaymentMethodFailed: {
            severity: 'HIGH',
            message: 'Failed to update payment method for autoship order',
        },
        EditPaymentMethodFailed: {
            severity: 'HIGH',
            message: 'Failed to edit payment method details for autoship order',
        },
        RemovePaymentMethodFailed: {
            severity: 'HIGH',
            message: 'Failed to remove payment method for autoship order',
        },
        EditAddressFailed: {
            severity: 'HIGH',
            message: 'Failed to edit address details for autoship order',
        },
        AddAddressFailed: {
            severity: 'HIGH',
            message: 'Failed to add address for autoship order',
        },
        RemoveAddressFailed: {
            severity: 'HIGH',
            message: 'Failed to remove address for autoship order',
        },
        SaveShippingAddressFailed: {
            severity: 'HIGH',
            message: 'Failed to save shipping address to autoship subscription',
        },
        AddPaymentMethodFailed: {
            severity: 'HIGH',
            message: 'Failed to add payment method for autoship order',
        },
        SkipItemFailed: {
            severity: 'HIGH',
            message: 'Failed to skip item from subscription',
        },
    },
    AutoshipUtils: {
        UnexpectedEveryPeriodValue: {
            severity: 'LOW',
            message: 'Unexpected everyPeriod value in formatFrequency',
        },
        SkipOrderFailed: {
            severity: 'HIGH',
            message: 'Failed to skip an order',
        },
    },
    ManageOrder: {
        SendNowFailed: {
            severity: 'HIGH',
            message: 'Failed to send autoship order now',
        },
    },
    PointsPayout: {
        FetchPointsPayoutFailed: {
            severity: 'HIGH',
            message: 'Failed to fetch points payout data from API',
        },
        ActivateRewardFailed: {
            severity: 'HIGH',
            message: 'Failed to activate points payout reward offer',
        },
    },
});
